import { DateTime } from 'luxon';

import { ALL_COUNTRIES_TIMEZONES, TimeFormat } from '@repo/common';

import type { Timezone } from '../types/timezone';

export { TimeFormat };

interface TimezoneItem {
  value: string;
  label: string;
  offset: string;
}

// Use the common timezones from the common package
export const timezoneList: Timezone[] = ALL_COUNTRIES_TIMEZONES.map((tz: TimezoneItem) => {
  const currentTime = DateTime.now().setZone(tz.value);
  const zone = currentTime.toFormat('ZZZ'); // Current timezone abbreviation

  // Create a human-readable name
  const humanReadableName = tz.value.replace('_', ' ').replace('/', ', ');

  return {
    iana: tz.value, // IANA timezone name
    name: humanReadableName, // Human-readable name
    label: tz.label, // Label from ALL_COUNTRIES_TIMEZONES
    offset: tz.offset, // Offset from ALL_COUNTRIES_TIMEZONES (e.g., "UTC+1")
    code: zone, // Current timezone abbreviation
  };
});
